export function isDummyNotificationRoute(route: string): boolean {
  return route === 'dummy'
}
